import { defineStore } from 'pinia';
import { store } from './index';

interface GlobalConfig {
  currency?: ValueLabelOptionItem[];
  channel_fee?: {
    channel_name: string;
    fee_columns: {
      column: string;
      label: string;
      fixed: boolean;
    }[];
  }[];

  [key: string]: any;
}

const defaultConfig = () =>
  ({
    channel_fee: [
      {
        channel_name: 'worldpay',
        fee_columns: [
          {
            column: 'markup_fee',
            label: 'Markup Fee',
            fixed: true,
          },
          {
            column: 'refund_fee',
            label: 'Refund Fee',
            fixed: false,
          },
          {
            column: 'gateway_fee',
            label: 'Gateway Fee',
            fixed: true,
          },
          {
            column: 'ic_fee',
            label: 'IC+Fee',
            fixed: true,
          },
          {
            column: '3d_fee',
            label: '3DS Fee',
            fixed: true,
          },
          {
            column: 'fraudsight_fee',
            label: 'FraudSight Fee',
            fixed: false,
          },
          {
            column: 'cbk_fee',
            label: 'CBK Fee',
            fixed: false,
          },
        ],
      },
      {
        channel_name: 'worldpay_us',
        fee_columns: [
          {
            column: 'markup_fee',
            label: 'Markup Fee',
            fixed: true,
          },
          {
            column: 'refund_fee',
            label: 'Refund Fee',
            fixed: false,
          },
          {
            column: 'gateway_fee',
            label: 'Gateway Fee',
            fixed: true,
          },
          {
            column: 'ic_fee',
            label: 'IC+Fee',
            fixed: true,
          },
          {
            column: '3d_fee',
            label: '3DS Fee',
            fixed: true,
          },
          {
            column: 'fraudsight_fee',
            label: 'FraudSight Fee',
            fixed: false,
          },
          {
            column: 'cbk_fee',
            label: 'CBK Fee',
            fixed: false,
          },
        ],
      },
      {
        channel_name: 'nuvei',
        fee_columns: [
          {
            column: 'markup_fee',
            label: 'Markup Fee',
            fixed: true,
          },
          {
            column: 'refund_fee',
            label: 'Refund Fee',
            fixed: false,
          },
          {
            column: 'gateway_fee',
            label: 'Gateway Fee',
            fixed: true,
          },
          {
            column: 'ic_fee',
            label: 'IC+Fee',
            fixed: true,
          },
          {
            column: '3d_fee',
            label: '3DS Fee',
            fixed: true,
          },
          {
            column: 'fraudsight_fee',
            label: 'FraudSight Fee',
            fixed: false,
          },
          {
            column: 'cbk_fee',
            label: 'CBK Fee',
            fixed: false,
          },
        ],
      },
      {
        channel_name: 'emerchant',
        fee_columns: [
          {
            column: 'markup_fee',
            label: 'Markup Fee',
            fixed: true,
          },
          {
            column: 'refund_fee',
            label: 'Refund Fee',
            fixed: false,
          },
          {
            column: 'gateway_fee',
            label: 'Gateway Fee',
            fixed: true,
          },
          {
            column: 'ic_fee',
            label: 'IC+Fee',
            fixed: true,
          },
          {
            column: '3d_fee',
            label: '3DS Fee',
            fixed: true,
          },
          {
            column: 'fraudsight_fee',
            label: 'FraudSight Fee',
            fixed: false,
          },
          {
            column: 'cbk_fee',
            label: 'CBK Fee',
            fixed: false,
          },
        ],
      },
      {
        channel_name: 'checkout',
        fee_columns: [
          {
            column: 'markup_fee',
            label: 'Markup Fee',
            fixed: true,
          },
          {
            column: 'refund_fee',
            label: 'Refund Fee',
            fixed: false,
          },
          {
            column: 'gateway_fee',
            label: 'Gateway Fee',
            fixed: true,
          },
          {
            column: 'ic_fee',
            label: 'IC+Fee',
            fixed: true,
          },
          {
            column: '3d_fee',
            label: '3DS Fee',
            fixed: true,
          },
          {
            column: 'fraudsight_fee',
            label: 'FraudSight Fee',
            fixed: false,
          },
          {
            column: 'cbk_fee',
            label: 'CBK Fee',
            fixed: false,
          },
        ],
      },
      {
        channel_name: 'citcon',
        fee_columns: [
          {
            column: 'markup_fee',
            label: 'Markup Fee',
            fixed: true,
          },
          {
            column: 'cbk_fee',
            label: 'CBK Fee',
            fixed: false,
          },
          {
            column: 'estimated_fee',
            label: '三方预估手续费',
            fixed: false,
          },
          {
            column: 'settlement_fee',
            label: 'Settlement Fee',
            fixed: false,
          },
        ],
      },
    ],
  } as GlobalConfig);

export const useGlobalConfigStore = defineStore('globalConfig', {
  state: () => ({
    config: defaultConfig(),
  }),
  actions: {
    setConfig(config?: GlobalConfig) {
      this.config = config || defaultConfig();
    },
    getChannelFeeColumns(channelName: string) {
      return (
        this.config.channel_fee
          ?.find(channel => channel.channel_name.toLowerCase() === channelName.toLowerCase())
          ?.fee_columns.filter(column => !column.fixed) || []
      );
    },
    clearConfig() {
      this.setConfig();
    },
  },
});

export function useGlobalConfigStoreHook() {
  return useGlobalConfigStore(store);
}
